import { filesize } from "filesize";

export function formatSizeDisplay(
    fileSizeBytes: number | null,
    pageCount: number | null
): string {
    const sizePart =
        fileSizeBytes != null ? filesize(fileSizeBytes, { round: 1 }) : null;
    const pagePart =
        pageCount != null
            ? `${pageCount} ${pageCount === 1 ? "page" : "pages"}`
            : null;

    if (sizePart && pagePart) return `${sizePart} \u00B7 ${pagePart}`;
    if (sizePart) return sizePart;
    if (pagePart) return pagePart;
    return "\u2014";
}
